import { SET_VIEW } from './types';
import { set, get, flatten, uniq, size, first, uniqBy } from 'global/lib/lodash';
import sendData from 'redux/actions/sendData';
import qs from 'qs';
import { TaskParams } from 'feature/task/TaskDetail';
import { SETTINGS } from 'feature/admin/account-settings';
import { getValidHex } from 'global/utils';
import { THEMEDEFAULTS } from 'global/components/app-theme-provider';
import { sortByDate } from 'global/utils';

export const addNewTask = (task) => (dispatch, getState) => {
  const sState = getState();
  const view = get(sState, 'view', {});
  const newTasks = get(view, 'task.new', []);
  if (task?.id && newTasks.some((t) => t.id === task.id)) return;
  set(view, 'task.new', [...newTasks, task]);
  set(view, 'task.ignored', []);
  dispatch({ type: SET_VIEW, view: { ...view } });
};

export const removeNewTask = (task) => (dispatch, getState) => {
  const sState = getState();
  const view = get(sState, 'view', {});
  const newTasks = get(view, 'task.new', []);
  set(
    view,
    'task.new',
    newTasks.filter((t) => t.id !== get(task, 'id'))
  );
  dispatch({ type: SET_VIEW, view: { ...view } });
};

export const setHasShownWelcome =
  (val = true) =>
  (dispatch, getState) => {
    const sState = getState();
    const view = get(sState, 'view', {});
    set(view, 'hasShownWelcome', val);
    dispatch({ type: SET_VIEW, view: { ...view } });
  };

export const ignoreNewTasks = (arr) => (dispatch, getState) => {
  const sState = getState();
  const view = get(sState, 'view', {});
  const newTasks = get(view, 'task.new', []);
  if (arr) {
    set(
      view,
      'task.ignored',
      newTasks.filter((t) => arr.indexOf(t.id) > -1)
    );
    set(
      view,
      'task.new',
      newTasks.filter((t) => arr.indexOf(t.id) === -1)
    );
  } else {
    set(view, 'task.ignored', [...newTasks]);
    set(view, 'task.new', []);
  }
  dispatch({ type: SET_VIEW, view: { ...view } });
};

export const undoIgnored = () => (dispatch, getState) => {
  const sState = getState();
  const view = get(sState, 'view', {});
  const ignored = get(view, 'task.ignored', []);
  const newTasks = get(view, 'task.new', []);
  set(view, 'task.ignored', []);
  set(view, 'task.new', [...newTasks, ...ignored]);
  dispatch({ type: SET_VIEW, view: { ...view } });
};

export const undoSent = () => (dispatch, getState) => {
  const sState = getState();
  const view = get(sState, 'view', {});
  const sent = get(view, 'task.sent', []);
  const newTasks = get(view, 'task.new', []);
  set(view, 'task.new', [...newTasks, ...sent]);
  dispatch({ type: SET_VIEW, view: { ...view } });
};

export const setNewTasksToSent =
  (arr, opts = {}) =>
  async (dispatch, getState) => {
    const sState = getState();
    const view = get(sState, 'view', {});
    const tasksNew = get(view, 'task.new', []);

    const newTasks = arr ? tasksNew.filter((task) => arr.indexOf(task.id) > -1) : tasksNew;
    const includeMe = (opts.emailCopy ? [sState.auth.user] : []).map(u => ({ id: u.id, type: 'users' }));

    const userMap = {
      // [id]: { usergroup id
      //   tasks: task,
      //   user: user,
      // }
    };

    newTasks.map((t) => {
      const assignees = get(t, 'assignees', []);
      const group = assignees
        .sort((a, b) => parseInt(get(a, 'id')) - parseInt(get(b, 'id')))
        .map((a) => {
          return a.id;
        })
        .join('_');

      set(userMap, group, {
        assignees,
        tasks: [...get(userMap, [group, 'tasks'], []), t],
      });
    });

    const messages = await Promise.all(
      Object.keys(userMap).map(async (k) => {
        let { tasks } = userMap[k];

        if (opts.status === 0) {
          tasks = newTasks;
        }

        //see if we need to create multiple realm id messages so that we can see them in archive view. Only SEND the first item = i
        const rids = [];
        tasks.map((t) => {
          const rid = get(t, 'realm.id');
          if (rids.indexOf(rid) === -1) {
            rids.push(rid);
          }
        });

        const taskUrl = (tsk) => `${window.location.origin}/tasks/detail/${get(tsk, 'id')}`;

        let body = (() => {
          const amt = size(tasks);
          let t = `You've been assigned ${amt} new task${amt > 1 ? 's' : ''}: <br /><br />`;
          t += tasks.map((tsk) => taskUrl(tsk)).join('<br />');
          t += '<br /><br />Please review the pdf here: ';
          return t;
        })();

        const relationships = {
          tasks: {
            data: tasks.map(t => ({ type: 'tasks', id: t.id })),
          },
          users: {
            data: uniqBy([ ...includeMe, ...flatten(tasks.map((task) => get(task, 'assignees', []).map((a) => ({ id: a.id, type: 'users' }))))], 'id')
          }
        }

        const results = await Promise.all(
          rids.map(async (r, i) => {
            const result = await sendData(
              {
                url: `/messages`,
                method: 'post',
                data: {
                  data: {
                    type: 'messages',
                    attributes: {
                      title: 'New Task',
                      body,
                      message_type: 'task_share',
                      model_type: 'task',
                      realm_id: r,
                      status: i === 0 ? 1 : 0,
                      separate_by_trades: !!opts.seperateByTrade,
                    },
                    relationships,
                  },
                },
              },
              { normalize: { build: ['messages'] }, params: { include: 'media' } }
            );
            return result;
          })
        );
        return first(results);
      })
    );

    set(view, 'task.ignored', []);
    set(view, 'task.new', arr ? tasksNew.filter((task) => arr.indexOf(task.id) === -1) : []);
    set(view, 'task.sent', [...newTasks]);
    dispatch({ type: SET_VIEW, view: { ...view } });
    return messages;
  };

export const updateTasksToLatest = () => async (dispatch, getState) => {
  const sState = getState();
  const view = get(sState, 'view', {});
  const newTasks = get(view, 'task.new', []);

  const upToDateTasks = await Promise.all(
    newTasks.map(async (task) => {
      const result = await sendData(
        {
          url: `/tasks/${task.id}?${qs.stringify(TaskParams.params)}`,
        },
        { normalize: { build: ['tasks'] } }
      );
      return get(result, '0');
    })
  );

  set(view, 'task.new', [...upToDateTasks]);
  dispatch({ type: SET_VIEW, view: { ...view } });
};

export const getAllAlerts =
  (page = 1) =>
  async (dispatch, getState) => {
    const [activities] = await Promise.all([
      await sendData(
        {
          url: `/activities?${qs.stringify({
            filter: { realmOnly: true },
            include: 'users,causer,realms,realms.parent,subject',
            page: { size: 25, number: page },
            sort: '-created_at',
          })}`,
        },
        { normalize: { build: ['activities'] } }
      ),
    ]);

    const sState = getState();
    const { view } = sState;

    const acts = activities || [];

    if (page === 1) {
      set(view, 'alerts.all', acts.reverse());
    } else {
      const previous = get(view, 'alerts.all', []);
      const all = uniqBy(sortByDate([...previous, ...acts], 'createdAt'), 'id');
      set(view, 'alerts.all', all);
    }

    return dispatch({ type: SET_VIEW, view: { ...view } });
  };

export const getAlerts =
  (page = 1) =>
  async (dispatch, getState) => {
    const [userActivities] = await Promise.all([
      await sendData(
        {
          url: `/activities?${qs.stringify({
            filter: { userOnly: 1 },
            include: 'users,causer,realms,subject,reads',
            page: { size: 25, number: page },
            sort: '-created_at',
          })}`,
        },
        { normalize: { build: ['activities'] } }
      ),
    ]);

    const sState = getState();
    const uid = get(sState, 'auth.user.id');
    const { view } = sState;

    const newActs = (userActivities || []).filter((a) => {
      if (size(get(a, 'reads')) === 0) {
        const causerid = get(a, 'causer.id');
        if (causerid != uid) {
          return true;
        }
        return false;
      }
      return false;
    });

    if (page === 1) {
      set(view, 'alerts.user', (userActivities || []).map((a) => ({ ...a, new: !!newActs.find((na) => get(na, 'id') == a.id) })).reverse());
      set(view, 'alerts.new', [ ...newActs ]);
    } else {
      const previous = get(view, 'alerts.user', []);
      const all = uniqBy(sortByDate([...previous, ...userActivities], 'createdAt'), 'id');
      set(view, 'alerts.user', all);
      set(view, 'alerts.new', uniqBy([...get(view, 'alerts.new', []), ...newActs], 'id'));
    }

    return dispatch({ type: SET_VIEW, view: { ...view } });
  };

export const addNewAlert = (alert) => (dispatch, getState) => {
  const { view } = getState();

  set(view, 'alerts.new', uniqBy([alert, ...get(view, 'alerts.new')], 'id'));
  set(view, 'alerts.user', uniqBy([alert, ...get(view, 'alerts.user')], 'id'));

  dispatch({ type: SET_VIEW, view: { ...view } });
}

export const clearNewAlert = (row, opts = {}) => (dispatch, getState) => {
  let { view } = getState();

  opts = {
    send: true,
    ...opts,
  }

  const userAlerts = get(view, 'alerts.user', []);
  const alerts = userAlerts.map((alert) => {
    return {
      ...alert,
      new: alert.id == row.id || alert.id == row.readable_id ? false : !!alert.new,
    }
  });

  if (opts.send) {
    sendData({
      url: `/read-statuses`,
      method: 'post',
      data: {
        data: {
          type: 'read-statuses',
          attributes: {
            readable_type: 'activity',
            readable_id: get(row, 'id'),
          },
        },
      },
    })
  }

  let found;
  const newAlerts = get(view, 'alerts.new', []).filter(alert => {
    const isMatch = alert.id == row.id || alert.id == row.readable_id ? true : false;
    if (isMatch) {
      found = true;
    }
    return !isMatch;
  })

  set(view, 'alerts.new', newAlerts);
  set(view, 'alerts.user', alerts);
  dispatch({ type: SET_VIEW, view: { ...view } });

  return found;
};

export const clearNewAlerts = () => async (dispatch, getState) => {
  let { view } = getState();

  const newAlerts = get(view, 'alerts.new', []);

  newAlerts.map(async (na) => {
    await sendData({
      url: `/read-statuses`,
      method: 'post',
      data: {
        data: {
          type: 'read-statuses',
          attributes: {
            readable_type: 'activity',
            readable_id: get(na, 'id'),
          },
        },
      },
    });
  })

  view = getState().view;
  set(view, 'alerts.new', []);
  set(view, 'alerts.user', view.alerts.user.map(u => { u.new = false; return u }));

  dispatch({ type: SET_VIEW, view: { ...view } });
};

export const getViewStyle = (rid, acctSettings) => async (dispatch, getState) => {
  const createThemeObject = (arr = []) => {
    const obj = {};
    Object.keys(SETTINGS).forEach((k) => {
      const item = arr.find((it) => get(it, 'name') === SETTINGS[k]);
      set(obj, k, get(item, 'value'));
    });
    return obj;
  };
  const accountSettings = acctSettings ? acctSettings : await sendData(
    { url: rid ? `/account-settings?realm_id=${rid}` : `/account-settings` },
    {
      normalize: { build: ['accountSettings'] },
    }
  );
  const themeObj = createThemeObject(accountSettings || []);
  dispatch(setViewStyle(themeObj));
};

export const setViewStyle = (themeObj) => (dispatch, getState) => {
  const view = getState().view;

  const mode = get(view, 'style.palette.mode', 'light');

  set(view, 'style', {
    palette: {
      mode,
      primary: {
        main: getValidHex(get(themeObj, 'primaryColor', get(view, 'style.palette.primary.main', get(THEMEDEFAULTS, 'palette.primary.main')))),
      },
      secondary: {
        main: getValidHex(get(themeObj, 'secondaryColor', get(view, 'style.palette.secondary.main', get(THEMEDEFAULTS, 'palette.secondary.main')))),
      },
    },
    props: {
      logo: get(themeObj, 'logo', get(view, 'style.props.logo')),
    },
  });
  set(view, 'hasLoadedTheme', true);

  dispatch({ type: SET_VIEW, view: { ...view } });
};

export const setTaskList = (list) => (dispatch, getState) => {
  const view = getState().view;
  set(view, 'task.list', list);
  dispatch({ type: SET_VIEW, view: { ...view } });
};

export const setView = (overrides) => (dispatch, getState) => {
  const view = getState().view;
  dispatch({ type: SET_VIEW, view: { ...view, ...overrides } });
};
